import { handleActions } from 'redux-actions'
import * as type from './type'
import { createInitialTableState, createReducerFunction, DESC } from '../../../table/state/reducer'


export const initialState = {
    appointmentList: [],
    fetching: false,
    error: null,
    ...createInitialTableState(type.APPOINTMENT_TABLE, 'appointment_appointment', {
        created: DESC,
    }),
}


export default handleActions({
    ...createReducerFunction(type.APPOINTMENT_TABLE),

}, initialState)



// WEBPACK FOOTER //
// ./src/modules/appointment/state/search/reducer.js